import React from 'react';
import { Redirect } from 'react-router';
import useRoutes from '../../hooks/useRoutes';

const PageBuddyCoChecklistRedirect: React.FC = () => {
  const { onboarding } = useRoutes();
  return <Redirect to={onboarding.credentials} />;
};

export default PageBuddyCoChecklistRedirect;
